// extracted by mini-css-extract-plugin
module.exports = {"price":"SummaryCartItemPrice_price__kgsEW"};